import { ICookieAction, ICookieState } from './cookie.types'
import { CookieConstants } from './cookie.constants'

export const initialCookieState: ICookieState = {
  cookie: '',
}

export function cookieReducer(state: ICookieState = initialCookieState, action: ICookieAction): ICookieState {
  switch (action.type) {
    case CookieConstants.SET_COOKIE:
      return { ...state, cookie: action.cookie }
    default:
      return state
  }
}
